import { VoucherModelType } from '@teinor/erp/types/company/accounting/voucher'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import { DisplayPriceGettingParams } from '../../../../../../../baseComponents/Displays/DisplayPrice'
import NullComponent from '../../../../../../../baseComponents/NullComponent'
import TwinTable from '../../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'
import { CustomRenderDateHours, CustomRenderString } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'


interface VouchersProps extends ComponentWithPermissions { }

const Vouchers: React.FC<VouchersProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('vouchers', 'Vales'),
        newText: '',
    }
    return (
        <BaseScreenTable TableComponent={TableVouchers} pageData={pageData} userPermissions={userPermissions} EditModalComponent={NullComponent} CreateModalComponent={NullComponent} />
    )
}

type TableVouchersProps = TableComponentProps & {}

const TableVouchers: React.FC<TableVouchersProps> = ({ userPermissions, setTableInstance }) => {
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<VoucherModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            width: 75,
            sortable: true
        },
        {
            id: 'voucher_n',
            dataKey: 'voucher_n',
            label: t('voucherN', 'Número de vale'),
            minWidth: 120,
            searchKey: 'voucher_n',
            customRender: (parameterValue, allRowData) => <CustomRenderString value={parameterValue} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('voucherN', 'Número de vale') }
            },
        },
        {
            id: 'reuses',
            dataKey: 'reuses',
            label: t('restUses', 'Usos restantes'),
            minWidth: 120,
        },
        {
            id: 'createdAt',
            dataKey: 'createdAt',
            label: t('date', 'Fecha'),
            sortable: true,
            customRender: (parameterValue) => <CustomRenderDateHours value={parameterValue} />
        },
        {
            id: 'amount',
            dataKey: 'amount',
            label: t('amount', 'Importe'),
            customRender: (parameterValue, allRowData) => <DisplayPriceGettingParams value={parseFloat(parameterValue)} with_vat={false} CurrencyId={allRowData.subType} />,
        },
        {
            id: 'usedAmount',
            dataKey: 'usedAmount',
            label: t('usedAmount', 'Importe usado'),
            customRender: (parameterValue, allRowData) => <DisplayPriceGettingParams value={parseFloat(parameterValue)} with_vat={false} CurrencyId={allRowData.subType} />,
        },
        {
            id: 'VoucherId',
            dataKey: 'VoucherId',
            label: t('voucherRelated', 'Vale relacionado'),
        },
        {
            id: 'SellTicketId',
            dataKey: 'SellTicketId',
            label: t('comesFrom', 'Proviene de'),
            minWidth: 200,
            searchKey: 'SellTicket.full_assigned_number',
            customRender: (parameterValue, allRowData) => <SellTicketFrom allRowData={allRowData} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('comesFrom', 'Proviene de') }
            },
        },
        {
            id: 'SellTicketRefundId',
            dataKey: 'SellTicketRefundId',
            label: t('comesFrom', 'Proviene de'),
            justForFilter: true,
            searchKey: 'SellTicketRefund.full_assigned_number',
            customRender: (parameterValue, allRowData) => <SellTicketFrom allRowData={allRowData} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('comesFrom', 'Proviene de') }
            },
        },
    ]
    return (
        <TwinTable name='Vouchers' columns={columns} getDataFrom='/api/app/order/tpv/sellTicket/getAllVouchers' setTableInstance={setTableInstance}/>
    )
}

interface SellTicketFromProps {
    allRowData: RowData
}

const SellTicketFrom: React.FC<SellTicketFromProps> = ({ allRowData }) => {
    const {t} = useTwinTranslation()
    let text = ''
    if (!allRowData.SellTicketRefund?.full_assigned_number && !allRowData.SellTicket?.full_assigned_number) {
        return null
    }
    if (allRowData.SellTicketRefundId) {
        text = t('refund', 'Devolución') + ': ' + allRowData.SellTicketRefund?.full_assigned_number
    } else {
        text = t('ticket', 'Ticket') + ': ' + allRowData.SellTicket?.full_assigned_number
    }
    return (<span>{text}</span>)
}


export default Vouchers